module.exports = __webpack_public_path__ + "static/img/LHL_g.f0af9753.png";